import { apiBase, createClient, tokenStore } from '@ck/sdk';

const saved = tokenStore('ck.partner.session');
const VIEW = 'ck.partner.view';
/** A product-demo link from the investor portal carries #as=<token>&demo=1. It lives only in this tab and never touches a real sign-in. */
(() => {
  const m = /[#&]as=([A-Za-z0-9_-]{20,})/.exec(location.hash);
  if (!m) return;
  try { sessionStorage.setItem(VIEW, m[1]!); } catch { /* ignore */ }
  history.replaceState(null, '', location.pathname + location.search);
})();
const viewToken = () => { try { return sessionStorage.getItem(VIEW); } catch { return null; } };
export const demoView = () => !!viewToken();
export const session = {
  get: () => viewToken() ?? saved.get(),
  set: (v: string | null) => { if (viewToken()) { if (!v) try { sessionStorage.removeItem(VIEW); } catch { /* ignore */ } return; } saved.set(v); },
};
export const CLIENT_URL = import.meta.env.VITE_CLIENT_URL ?? 'https://client.ckfundedpro.com';

let onSignedOut: () => void = () => undefined;
export const setSignedOutHandler = (fn: () => void) => { onSignedOut = fn; };

export const API_BASE = apiBase(import.meta.env.VITE_API_URL);
export const api = createClient({
  baseUrl: apiBase(import.meta.env.VITE_API_URL),
  tenant: import.meta.env.VITE_TENANT || undefined,
  token: () => session.get(),
  onUnauthorized: () => { session.set(null); onSignedOut(); },
});
